import { ObjectFieldsChecker } from 'by/gamefactory/tools/ObjectFieldsChecker';
import * as chains from 'viem/chains';
import { Chain } from 'viem/chains';

const chainMap = new Map<number, Chain>(Object.values(chains).map((value) => {
    try {
        ObjectFieldsChecker.throwIfInvalidFields(value, [ "id", "name", "nativeCurrency", "rpcUrls" ]);
        return [ value.id as number, value as Chain ];
    }
    catch {
        return null;
    }
}));

export class ChainUtils {
    public static idToHex(id: number): string {
        return `0x${id.toString(16)}`;
    }

    public static hexToId(id: string): number {
        return parseInt(id);
    }

    public static nameFromId(id: number | string): string {
        if (typeof id === "string") {
            id = ChainUtils.hexToId(id);
        }
        if (!chainMap.has(id)) {
            return "unknown chain";
        }
        return chainMap.get(id).name;
    }
}